export const ENVS = {
  PROD: 'prod',
  PP1: 'pp1',
  PP2: 'pp2',
  PP3: 'pp3',
  PT1: 'pt1',
};

export const JURISDICTIONS = {
  COM: 'com',
  ES: 'es',
  IT: 'it',
};

export const LANG_COOKIE_NAME = 'cust_lang';

export const LANG_ISO_CODES = {
  EN: 'en-gb',
  DE: 'de-de',
  RU: 'ru-ru',
  GR: 'el-gr',
  JP: 'ja-jp',
};
